import React from 'react';
import { Tab, Tabs } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import routes from 'constants/routes';

const NAV_TABS = [
	{ value: routes.providerPayments.list, label: 'Órdenes de compra' },
	{ value: routes.providerPayments.schedule, label: 'Agenda de pagos' },
	{ value: routes.providerPayments.payments, label: 'Pagos realizados' },
	{ value: routes.providerPayments.bulk, label: 'Importar masivo' },
];

export const ProviderPaymentsNav = (): JSX.Element => {
	const history = useHistory();
	const location = useLocation();

	const activeTab = NAV_TABS.some((t) => t.value === location.pathname) ? location.pathname : false;

	return (
		<Tabs
			value={activeTab}
			onChange={(_, val) => history.push(val)}
			sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
			variant="scrollable"
			scrollButtons="auto"
		>
			{NAV_TABS.map((tab) => (
				<Tab key={tab.value} label={tab.label} value={tab.value} />
			))}
		</Tabs>
	);
};
